import type { Memory } from '@repo/common';

function getDateStr(inputDate: Date): string {
  const year = inputDate.getFullYear();
  const month = String(inputDate.getMonth() + 1).padStart(2, '0'); // Month is 0-based
  const day = String(inputDate.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export type CalendarFocusSource = 'click' | 'context-menu' | 'nav' | 'programmatic' | null;

export interface CalendarViewer {
  currentDate: string;
  timeGrain: 'day' | 'week' | 'month';
  popoverCalendarEvent: Memory | null | undefined;
  focusedEventId?: string | null;
  focusSource?: CalendarFocusSource;
}

export const DEFAULT_CALENDAR_VIEWER: CalendarViewer = {
  currentDate: getDateStr(new Date()),
  timeGrain: 'week',
  popoverCalendarEvent: null,
  focusedEventId: null,
  focusSource: null
};
